module.exports = __webpack_public_path__ + "static/media/AH_Logo.0d85019b.png";